import { msg } from "@lingui/core/macro";
import type { MessageDescriptor } from "@lingui/core";
import type { MessageFeedbackReason } from "@sage-mcp/shared";

// Reason labels for end-user reports on assistant replies. Descriptors rather
// than <Trans> so the same list drives the filter dropdown, the list badges and
// the conversation detail. Wording is kept close to the local-app picker
// (packages/local-app/src/chat/message-feedback.tsx) so support reads the same
// phrase the customer clicked.
export const FEEDBACK_REASON_LABELS: Record<MessageFeedbackReason, MessageDescriptor> = {
  missing_permission: msg`Missing access rights`,
  cannot_answer: msg`Said it could not answer`,
  incorrect_answer: msg`Wrong answer`,
  no_answer: msg`No answer at all`,
  incomplete_answer: msg`Incomplete answer`,
  data_mismatch: msg`Data does not match Sage`,
  misunderstood: msg`Misunderstood the question`,
  tool_error: msg`Technical or tool error`,
  other: msg`Other`,
};
